import React from 'react'
import { Link } from 'react-router-dom'

function OfferTwo() {
    return (
        <section
            className="position-relative overflow-hidden space-bottom"
            id="destination-sec"
        >
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">What We Offer</span>
                    <h2 className="sec-title">Our Adventure Services</h2>
                </div>
                <div className="row gy-4 gx-4">
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_1.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Guided Mountain Tours</Link>
                                </h3>
                                <p className="destination-text">Skardu & Hunza</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_2.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Trekking & Hiking</Link>
                                </h3>
                                <p className="destination-text">Fairy Meadows & Beyond</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_3.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Camping & Outdoors</Link>
                                </h3>
                                <p className="destination-text">Bonfire & BBQ Included</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_4.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Honeymoon Packages</Link>
                                </h3>
                                <p className="destination-text">Skardu & Hunza</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_5.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Customized Tour Packages</Link>
                                </h3>
                                <p className="destination-text">Tailored to Your Group</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_6.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Nature & Cultural Exploration</Link>
                                </h3>
                                <p className="destination-text">Forts, Lakes & Villages</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_7.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Luxury Prado Transport</Link>
                                </h3>
                                <p className="destination-text">Comfortable & Safe Travel</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/destination_4_8.jpg" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/contact">Blossom Season Tours</Link>
                                </h3>
                                <p className="destination-text">Spring in Skardu & Hunza</p>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default OfferTwo

